<template>
	<!-- 票品复制弹层：支持同场次/跨场次复制（可多选目标场次一次生成多条），保存即生效 -->
	<el-drawer title="复制票品" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true"
		size="auto" @close="close">
		<div class="drawer-content">
			<el-alert type="info" :closable="false" title="源票品">
				将复制「{{ sourceTicket && sourceTicket.sessionName }} · {{ sourceTicket &&
					sourceTicket.ticketName }}」的票品配置:售价{{ sourceTicket && sourceTicket.sellPrice }}元/原价{{ sourceTicket &&
					sourceTicket.originalPrice }}元/库存{{ sourceTicket && sourceTicket.totalNum }}/{{ limitView }}
			</el-alert>
			<el-form :model="formData" :rules="rules" ref="formData" label-position="top" class="MT30">
				<el-form-item prop="ticketName" label="新票品名称:">
					<span slot="label">
						新票品名称：
						<small class="color-info">相同场次内票品名称不可重复</small>
					</span>
					<el-input v-model="formData.ticketName" placeholder="请输入新票品名称" maxlength="20"
						show-word-limit></el-input>
				</el-form-item>
				<el-form-item prop="sessionIds" label="复制到目标场次:">
					<el-checkbox-group v-model="formData.sessionIds">
						<el-checkbox v-for="item in sessionList" :key="item.id" :label="item.id" border>
							{{item.sessionName}}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
			<el-alert type="warning" :closable="false" class="MB20">
				<p>复制生成的新票品将继承原票品的售价、原价、售票时间、库存、限购、实名规则、票品说明等全部配置，保存后请按需更新票价、售票时间、库存等信息。</p>
			</el-alert>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">取 消</el-button>
			<el-button type="primary" @click="submitForm" :loading="btnLoading">确 定</el-button>
		</div>
	</el-drawer>
</template>

<script>
// 默认表单数据
const defaultFormData = {
	ticketName: '',
	sessionIds: []
}
export default {
	props: {
		// 演出id
		activityId: {
			type: [Number, String],
			default: () => null
		}
	},
	data() {
		return {
			drawerShow: false,
			btnLoading: false,
			formData: {...defaultFormData},
			// 源票品
			sourceTicket: null,
			// 可选场次列表（含源场次所在列表页数据，含场次名与场次下已有票品名）
			sessionList: [],
			rules: {
				ticketName: [{required: true, message: '请输入新票品名称'}],
				sessionIds: [{required: true, message: '请至少勾选一个目标场次'}]
			}
		}
	},
	computed: {
		// 限购展示：0=不限购
		limitView() {
			const _num = this.sourceTicket && this.sourceTicket.accountLimitNum;
			return _num == 0 ? '不限购' : `限购${_num}张`;
		}
	},
	methods: {
		/**
		 * 打开弹层
		 * @param {Object} ticket 源票品行数据
		 * @param {Object} session 源票品所在场次 {sessionId, sessionName}
		 * @param {Array} sessionList 列表页所有场次数据 [{sessionId, sessionName, ticketPrices}]
		 */
		show(ticket, session, sessionList) {
			this.sourceTicket = {
				...ticket,
				sessionName: session && session.sessionName || ''
			};
			this.sessionList = (sessionList || []).map(v => ({
				id: v.sessionId,
				sessionName: v.sessionName,
				ticketPrices: v.ticketPrices || []
			}));
			// 仅有一个场次时默认选中该场次，多个场次需手动勾选
			const _sessionIds = this.sessionList.length == 1 ? [this.sessionList[0].id] : [];
			this.formData = {
				...defaultFormData,
				sessionIds: _sessionIds
			};
			this.drawerShow = true;
		},
		// 关闭并重置
		close() {
			this.formData = {...defaultFormData};
			this.$nextTick(() => {
				this.$refs.formData && this.$refs.formData.resetFields();
				this.$refs.formData && this.$refs.formData.clearValidate();
			});
			this.drawerShow = false;
		},
		// 提交复制
		submitForm() {
			this.$refs.formData.validate((valid) => {
				if (!valid) return;
				// 本地重名预检：目标场次中已存在同名票品则拦截（后端有兜底，此处优化体验）
				const _dupSession = this.sessionList.find(s => this.formData.sessionIds.includes(s.id) &&
					s.ticketPrices.some(t => t.ticketName == this.formData.ticketName.trim()));
				if (_dupSession) {
					return this.$message.error(`【${_dupSession.sessionName}】中已存在同名票品，请修改票品名称`);
				}
				this.btnLoading = true;
				this.$request({
					url: '/activity/copyTP',
					method: 'POST',
					data: {
						ticketPriceId: this.sourceTicket.id,
						ticketName: this.formData.ticketName.trim(),
						sessionIds: this.formData.sessionIds
					}
				}).then((res) => {
					const {state, msg} = res.data;
					if (state == 1) {
						this.$message.success('复制成功');
						this.close();
						// 通知父组件刷新列表
						this.$emit('onUpdate');
					} else {
						this.$message.error(msg || '复制失败');
					}
				}).catch(() => {
					this.$message.error('请求错误');
				}).finally(() => {
					this.btnLoading = false;
				});
			});
		}
	}
}
</script>

<style lang="scss" scoped>
/* 复制弹层样式 */
.drawer-content {
	.el-checkbox-group {
		display: flex;
		flex-direction: column;
		gap: 6px;
		.el-checkbox {
			margin: 0;
		}
	}
}
</style>
